import { DeliveryProvider } from '../../../../services/exports/Constants';

export default {
  [DeliveryProvider.Standalone]: 'Restaurant drivers fleet',
  [DeliveryProvider.UberDrive]: 'Uber drive',
  [DeliveryProvider.WoltDrive]: 'Wolt drive',
};
